/* BAF Saat — favoriler (tarayıcıda saklanır; Swym entegrasyonu kararı sonrası değiştirilebilir). */
(() => {
  const ANAHTAR = 'bs-favoriler';
  const oku = () => {
    try { return JSON.parse(localStorage.getItem(ANAHTAR) || '[]'); } catch { return []; }
  };
  const yaz = (liste) => {
    try { localStorage.setItem(ANAHTAR, JSON.stringify(liste)); } catch { /* gizli pencere */ }
  };
  const isaretle = (kok = document) => {
    const liste = oku().map((f) => String(f.id));
    kok.querySelectorAll('[data-bs-favori]').forEach((b) => {
      b.setAttribute('aria-pressed', liste.includes(b.dataset.urunId) ? 'true' : 'false');
    });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bs-favori]');
    if (!b) return;
    e.preventDefault();
    let liste = oku();
    const id = String(b.dataset.urunId);
    if (liste.some((f) => String(f.id) === id)) liste = liste.filter((f) => String(f.id) !== id);
    else liste.unshift({ id, url: b.dataset.urunUrl });
    yaz(liste.slice(0, 100));
    isaretle();
    document.dispatchEvent(new CustomEvent('bs:favori', { detail: { sayi: liste.length } }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => isaretle());
  else isaretle();
  new MutationObserver(() => isaretle()).observe(document.documentElement, { childList: true, subtree: true });
  window.bsFavoriler = oku;
})();
